import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DrugSearchAjax {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  DrugSearchAjaxData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: DrugSearchAjax = {
  isLoading: false,
  error: false,
  message: null,
  DrugSearchAjaxData: [],
  Items: [],
  Pagination: [],
};

const DrugSearchAjaxSlice = createSlice({
  name: "DrugSearchAjax",
  initialState,
  reducers: {
    loadingDrugSearchAjax: (
      state: DrugSearchAjax,
      action: PayloadAction<{}>
    ) => {
      state.isLoading = true;
    },
    setDrugSearchAjax: (state: any, action: PayloadAction<DrugSearchAjax>) => {
      return action.payload;
    },
    clearData: (state: DrugSearchAjax, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loadingDrugSearchAjax, setDrugSearchAjax, clearData } =
  DrugSearchAjaxSlice.actions;

export default DrugSearchAjaxSlice.reducer;
